import Card from 'components/card';
import InputField from 'components/fields/InputField';
import Switch from 'components/switch';
import ProductBarcode from 'components/dataDisplay/Barcode';
import { useState } from 'react';
import Checkbox from 'components/checkbox';
import SearchSelector from 'components/fields/SearchSelector';

const BrutProductForm = (props: {
    state: number;
    newProduct: any;
    setState: any;
    handleProductChange: any;
    suppliers?: any[];
    allProducts?: any[];
}) => {
    const { state, newProduct, setState, handleProductChange, suppliers = [], allProducts = [] } = props;

    const switchSellProduct = () => {
        handleProductChange(
            'category',
            newProduct.category === 'hidden' ? '' : 'hidden',
        );
    };

    const [openSuppliers, setOpenSuppliers] = useState(false);
    const supplierIds: string[] = Array.isArray(newProduct.suppliers)
        ? newProduct.suppliers
        : [];
    const toggleSupplier = (id: string) => {
        const next = supplierIds.includes(id)
        ? supplierIds.filter((s) => s !== id)
        : [...supplierIds, id];
    handleProductChange('suppliers', next);
    if (state === 0) setState(1);
};

    return (
        <div className="px-3">
    <Card extra="mt-3 w-full !p-5 border">
        <h4 className="text-lg font-medium text-navy-700 dark:text-white">
            Produit brut
        </h4>

        {/* SECTION 1 — LIGNE 1 */}
        <div className="mt-4 grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-3">
                <InputField
                    label="Nom*"
                    placeholder="Jus d'orange"
                    id="name"
                    type="text"
                    onChange={(e: any) => {
                        handleProductChange("name", e.target.value);
                        if (state === 0) setState(1);
                    }}
                    inputSmall
                />
            </div>

            <div className="col-span-12 md:col-span-3">
                <InputField
                    label="Référence*"
                    placeholder="JO-00001"
                    value={newProduct.ref}
                    id="ref"
                    type="text"
                    onChange={(e: any) => {
                        handleProductChange("ref", e.target.value);
                        if (state === 0) setState(1);
                    }}
                    inputSmall
                />
            </div>

            <div className="col-span-12 md:col-span-3">
                <InputField
                    label="Origine"
                    placeholder="France"
                    value={newProduct.origin}
                    id="origin"
                    type="text"
                    onChange={(e: any) => {
                        handleProductChange("origin", e.target.value);
                        if (state === 0) setState(1);
                    }}
                    inputSmall
                />
            </div>

            <div className="col-span-12 md:col-span-3">
                <InputField
                    label="Unité*"
                    placeholder="Kg"
                    value={newProduct.unity}
                    id="unity"
                    type="text"
                    onChange={(e: any) => {
                        handleProductChange("unity", e.target.value);
                        if (state === 0) setState(1);
                    }}
                    inputSmall
                />
            </div>
        </div>

        {/* SECTION 2 — FOURNISSEURS (pleine ligne sur desktop) */}
        <div className="mt-4 grid grid-cols-12 gap-4">
            <div className="col-span-12 lg:col-span-6">
                <label className="text-navy-700 text-xs font-medium">Fournisseurs</label>

                <div className="relative mt-2">
                    <button
                        type="button"
                        onClick={() => setOpenSuppliers((o) => !o)}
                        className="flex w-full items-center justify-between rounded-md border border-gray-300 bg-white px-3 py-2 text-left text-sm text-gray-700 hover:border-toola-500"
                    >
                        {supplierIds.length === 0
                            ? "Aucun fournisseur sélectionné"
                            : `${supplierIds.length} fournisseur(s) sélectionné(s)`}
                        <span className="text-xs text-gray-400">
                            {openSuppliers ? "▲" : "▼"}
                        </span>
                    </button>

                    {openSuppliers && (
                        <div className="absolute z-30 mt-1 max-h-60 w-full overflow-auto rounded-md border border-gray-200 bg-white p-2 shadow-lg">
                            {suppliers.length === 0 && (
                                <p className="p-2 text-xs text-gray-500">
                                    Aucun fournisseur disponible
                                </p>
                            )}
                            {suppliers.map((s) => (
                                <label
                                    key={s._id}
                                    className="flex cursor-pointer items-center gap-2 rounded px-2 py-1 text-sm hover:bg-gray-50"
                                >
                                    <input
                                        type="checkbox"
                                        className="h-4 w-4 accent-toola-500"
                                        checked={supplierIds.includes(s._id)}
                                        onChange={() => toggleSupplier(s._id)}
                                    />
                                    <span>{s.displayName || s.company}</span>
                                </label>
                            ))}
                        </div>
                    )}
                </div>

                {supplierIds.length > 0 && (
                    <div className="mt-2 flex flex-wrap gap-2">
                        {supplierIds.map((id) => {
                            const sup = suppliers.find((s) => s._id === id);
                            return (
                                <span
                                    key={id}
                                    className="flex items-center gap-1 rounded-full bg-toola-500/10 px-2 py-1 text-xs text-toola-600"
                                >
                                    {sup?.displayName || sup?.company}
                                    <button
                                        type="button"
                                        onClick={() => toggleSupplier(id)}
                                        className="text-toola-500 hover:text-toola-700"
                                    >
                                        ✕
                                    </button>
                                </span>
                            );
                        })}
                    </div>
                )}
            </div>

            <div className="col-span-12 lg:col-span-6">
                <InputField
                    label="Code EAN (EAN-13)"
                    placeholder="1234567890123"
                    value={newProduct.ean || ''}
                    id="ean"
                    type="text"
                    onChange={(e: any) => {
                        const val = e.target.value.replace(/\D/g, '').slice(0, 13);
                        handleProductChange('ean', val);
                        if (state === 0) setState(1);
                    }}
                    inputSmall
                />
                <div className="mt-4 flex justify-center items-center h-[50px]">
                    <ProductBarcode ean={newProduct.ean} />
                </div>
            </div>
        </div>

        {/* SECTION 3 — VAT LINE + CATEGORY + ACCOUNTING CODE */}
        <div className="mt-4 grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-3">
                <InputField
                    label="TVA fournisseur (%)"
                    placeholder="5.5"
                    id="vatPurchase"
                    type="number"
                    value={newProduct.vatPurchase}
                    onChange={(e: any) => handleProductChange("vatPurchase", e.target.value)}
                    inputSmall
                />
            </div>

            <div className="col-span-12 md:col-span-3">
                <InputField
                    label="Catégorie (facture)"
                    placeholder="Cat 2"
                    id="productCategory"
                    onChange={(e: any) =>
                        handleProductChange("productCategory", e.target.value)
                    }
                    inputSmall
                />
            </div>

            <div className="col-span-12 md:col-span-3">
                <InputField
                    label="Code comptable"
                    placeholder="701000"
                    id="accountingCode"
                    onChange={(e: any) =>
                        handleProductChange("accountingCode", e.target.value)
                    }
                    inputSmall
                />
            </div>
        </div>

        {/* SECTION 4 — PRIX / ALERTES / DLC */}
        <div className="mt-4 grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-3">
                <InputField
                    label="Prix d'achat (€)"
                    placeholder="0"
                    id="purchasePrice"
                    type="number"
                    onChange={(e: any) => handleProductChange("purchasePrice", e.target.value)}
                    inputSmall
                />
            </div>

            <div className="col-span-12 md:col-span-3">
                <InputField
                    label="Prix de vente (€)"
                    placeholder="15"
                    id="price"
                    type="number"
                    onChange={(e: any) => handleProductChange("price", e.target.value)}
                    inputSmall
                />
            </div>

            <div className="col-span-12 md:col-span-3">
                <InputField
                    label="Seuil d'alerte"
                    placeholder={`150 ${newProduct.unity}`}
                    id="alert"
                    type="number"
                    onChange={(e: any) => handleProductChange("alert", e.target.value)}
                    inputSmall
                />
            </div>

            <div className="col-span-12 md:col-span-3">
                <InputField
                    label="DLC (jours)"
                    placeholder="Durée"
                    id="daysOfConservation"
                    type="number"
                    onChange={(e: any) =>
                        handleProductChange("daysOfConservation", e.target.value)
                    }
                    inputSmall
                />
            </div>

            <div className="col-span-12 md:col-span-3">
                <InputField
                    label="Alerte DLC (jours)"
                    placeholder="Prévenir X jours avant"
                    id="dlcAlert"
                    type="number"
                    onChange={(e: any) => handleProductChange("dlcAlert", e.target.value)}
                    inputSmall
                />
            </div>

            <div className="col-span-12 md:col-span-3">
                <InputField
                    label="TVA (%)"
                    placeholder="5.5"
                    id="vat"
                    type="number"
                    onChange={(e: any) => handleProductChange("vat", e.target.value)}
                    inputSmall
                />
            </div>

            <div className="col-span-12 md:col-span-3">
                <InputField
                    label="Poids brut (Kg)"
                    placeholder="0"
                    id="brutWeight"
                    type="number"
                    onChange={(e: any) => handleProductChange("brutWeight", e.target.value)}
                    inputSmall
                />
            </div>

            <div className="col-span-12 md:col-span-3">
                <InputField
                    label="Poids net (Kg)"
                    placeholder="0"
                    id="netWeight"
                    type="number"
                    onChange={(e: any) => handleProductChange("netWeight", e.target.value)}
                    inputSmall
                />
            </div>
        </div>

        {/* SECTION 4.5 — VISIBILITY */}
        <div className="mt-4 grid grid-cols-12 gap-4 items-center">
            <div className="col-span-12 md:col-span-3 flex items-center">
                 <Checkbox
                    id="hideWhenOutOfStock"
                    checked={newProduct.hideWhenOutOfStock}
                    onChange={(e: any) => handleProductChange("hideWhenOutOfStock", e.target.checked)}
                />
                <label
                    htmlFor="hideWhenOutOfStock"
                    className="ml-2 text-sm font-bold text-navy-700 dark:text-white"
                >
                    Masquer si rupture
                </label>
            </div>

            <div className="col-span-12 md:col-span-9">
                 <SearchSelector
                    label="Ajouter un produit de remplacement"
                    options={allProducts.filter((p: any) => !(newProduct.replacementProducts || []).includes(p._id))}
                    displayKey="name"
                    onSelect={(p: any) => {
                        const current = Array.isArray(newProduct.replacementProducts) ? newProduct.replacementProducts : [];
                        handleProductChange("replacementProducts", [...current, p._id]);
                    }}
                    value={null}
                    inputSmall={true}
                />
                <div className="flex flex-wrap gap-2 mt-2">
                    {(newProduct.replacementProducts || []).map((id: string) => {
                        const prod = allProducts.find((p) => p._id === id);
                        return (
                            <div key={id} className="flex items-center gap-2 bg-white border border-gray-200 rounded-full px-3 py-1">
                                <span className="text-sm text-navy-700">{prod?.name || 'Produit inconnu'}</span>
                                <button
                                    onClick={() => {
                                        const current = Array.isArray(newProduct.replacementProducts) ? newProduct.replacementProducts : [];
                                        handleProductChange("replacementProducts", current.filter((i: string) => i !== id));
                                    }}
                                    className="text-gray-400 hover:text-red-500 font-bold ml-1"
                                >
                                    ×
                                </button>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>

        {/* SECTION 5 — SWITCH */}
        <div className="mt-4 grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-3 flex items-center justify-between">
                <label className="text-xs font-medium text-navy-700">
                    Vente possible*
                    <p className="mt-1 text-xs text-gray-600">
                        Le produit brut est disponible à la vente.
                    </p>
                </label>

                <Switch
                    onChange={switchSellProduct}
                    id="sell"
                    checked={newProduct.category === ""}
                    color="toola"
                />
            </div>
        </div>
    </Card>
</div>
    );
};

export default BrutProductForm;
